import { render, staticRenderFns } from "./LeadsGridContentHistory.vue?vue&type=template&id=51abb5f6"
import script from "./LeadsGridContentHistory.vue?vue&type=script&lang=ts"
export * from "./LeadsGridContentHistory.vue?vue&type=script&lang=ts"
import style0 from "./LeadsGridContentHistory.vue?vue&type=style&index=0&id=51abb5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports